import { Outlet } from 'react-router-dom';
import Sidebar from '@/components/layouts/Sidebar';
const Layout = () => {
  return (
    <div className="flex min-h-screen overflow-x-hidden" style={{ backgroundColor: '#F8F9FC' }}>
      <Sidebar />
      <main className="flex-1 pl-0 md:pl-64 pt-16 md:pt-0 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
};
export default Layout;
